import { Answer } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import React, { useCallback, useEffect, useState } from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';

interface FeedbackEmptyAnswerProps {
  reportId: number;
  answer: Answer | undefined;
  questionId: number | undefined;
  selectedIndex: number | undefined;
}

const StyledDiv = styled.div`
  padding: ${SPACERS.large};
`;

const FeedbackEmptyAnswer: React.FC<FeedbackEmptyAnswerProps> = ({
  answer,
  questionId,
  selectedIndex,
}) => {
  if (answer || !questionId || selectedIndex === undefined) {
    return null;
  }
  switch (questionId) {
    case 40015:
    case 50001:
    case 50002:
      return (
        <StyledDiv>
          <TrueImpactText color="critical">
            Impact model wasn't saved properly.
          </TrueImpactText>
        </StyledDiv>
      );
    default:
      return null;
  }
};

export default FeedbackEmptyAnswer;
